var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 9.02126C9.8395 7.65958 7.87098 7.65958 7.03759 9.02126L2.31997 16.7294C2.07055 17.1369 1.97533 17.5778 2.00535 18V20C2.00535 21.1046 2.90078 22 4.00535 22H20C21.1046 22 22 21.1046 22 20V18H21.9946C22.026 17.5614 21.9223 17.1032 21.6517 16.6845L18.6481 12.0384C17.8065 10.7365 15.9109 10.7365 15.0692 12.0384L13.7595 14.0644L10.6729 9.02126Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains1);
export default __webpack_public_path__ + "static/media/mountains-1.82bf4c7ad2d80d25c361bb66a7189a6a.svg";
export { ForwardRef as ReactComponent };